import React, { type PropsWithChildren } from 'react';

import { Stack, type StackProps } from '@atlaskit/primitives/compiled';
import { cssMap, cx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const layoutSectionStyles = cssMap({
	box: {
		paddingTop: token('space.600'),
		paddingRight: token('space.600'),
		paddingBottom: token('space.600'),
		paddingLeft: token('space.600'),
	},
	// Default styles for the layout section
});

type ContentLayoutSectionProps = PropsWithChildren & {
	space?: StackProps['space'];
};

const ContentLayoutSection = ({ children, space = 'space.300' }: ContentLayoutSectionProps) => {
	return (
		<Stack space={space} xcss={cx(layoutSectionStyles.box)}>
			{children}
		</Stack>
	);
};

export { ContentLayoutSection };
